import React from 'react';

export interface Image {
	src: string;
	title: string | React.ReactElement;
	alt?: string;
	style?: React.CSSProperties;
	link?: string;
	width?: number;
}

export function getImagePath(avatar: string | undefined | null, height?: number, width?: number, hostServer?: string): string {
	if (!avatar) {
		return '';
	}

	const getArguments = (height?: number, width?: number, heightParam?: string, widthParam?: string, prefix?: string) => {
		const params: Array<string> = [];

		if (height) {
			params.push(`${heightParam}=${height}`);
		}
		if (width) {
			params.push(`${widthParam}=${width}`);
		}

		if (params.length) {
			return (prefix || '') + params.join('&');
		}

		return '';
	};

	if (avatar.indexOf('http') === -1) {
		if (avatar.startsWith('observed') && hostServer) {
			return `api/resize?src=${hostServer}${hostServer.endsWith('/') ? '' : '/'}${avatar}${getArguments(height, width, 'height', 'width', '?')}`;
		}

		return `${avatar}${getArguments(height, width, 'height', 'width', '?')}`;
	}

	return `api/resize?src=${encodeURIComponent(avatar)}${getArguments(height, width, 'maxHeight', 'maxWidth', '&')}`;
}
